import { I18nComponente } from "@/types/gerais"

export const MCabecalhoTabelaGrupoi18n: I18nComponente = {
  "pt-BR": {
    editarGrupo: "editar grupo",
    deletarGrupoDeProjetos: "deletar grupo de projetos",
    umUsuarioResponsavel: "1 usuário responsável",
    usuariosResponsaveis: "usuários responsáveis",
  },
  "es-CO": {
    editarGrupo: "editar grupo",
    deletarGrupoDeProjetos: "borrar grupo de proyectos",
    umUsuarioResponsavel: "1 usuario responsable",
    usuariosResponsaveis: "usuarios responsables",
  },
}
